<template>
  <div class="userManger">
    <el-row class="common-box">
      <div class="common-box-btn clearfix">
        <h2 class="floatl">用户管理</h2>
        <el-button type="primary" size="mini" class="el-icon-plus newUser" @click="showNewUserDialog" :disabled="auths.indexOf(2) == -1"> 创建用户</el-button>
      </div>
      <div class="common-search">
        <el-form :inline="true" label-width="70px" class="formInline" size="mini">
          <el-form-item label="姓名">
            <el-input v-model="formData.nickName" placeholder="请输入姓名..." :maxlength="5"></el-input>
          </el-form-item>
          <el-form-item label="手机号">
            <el-input v-model="formData.tel" placeholder="请输入手机号码..." :maxlength="11"></el-input>
          </el-form-item>
          <el-form-item label="人员编码">
            <el-input v-model="formData.empCode" placeholder="请输入人员编码..." :maxlength="100"></el-input>
          </el-form-item>
          <el-form-item label="角色">
            <el-select v-model="formData.roleId" filterable placeholder="请选择...">
              <el-option label="不限" value=""></el-option>
              <el-option v-for="(item,index) in roleList" :key="index" :label="item.roleName" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item style="vertical-align: bottom;">
            <el-button class="search-btn" @click="getData(true)">筛选</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="common-box-body">
        <!-- table主体 -->
        <el-table class="table-expand" :data="tableData" ref="table" size="small" v-loading="listLoading"
                  element-loading-text="拼命加载中" border header-row-class-name="table-header">

          <el-table-column type="index" label="编号" width="50" align="center"></el-table-column>
          <el-table-column prop="sysUser.nickName" label="姓名" width="145" align="center"></el-table-column>
          <el-table-column prop="sysUser.empCode" label="人员编码" width="145" align="center"></el-table-column>
          <el-table-column prop="sysUser.tel" label="手机号" width="182" align="center"></el-table-column>
          <el-table-column prop="sysUser.mail" label="邮箱" width="290" align="center"></el-table-column>
          <el-table-column prop="sysUser.account" label="用户名" width="185" align="center"></el-table-column>
          <el-table-column v-if="isAdmin" prop="sysUser.password" label="密码"
                           width="120" align="center"></el-table-column>
          <el-table-column prop="sysRole.roleName" label="角色" width="290" align="center"></el-table-column>
          <el-table-column label="项目" width="130" align="center">
            <template slot-scope="props">
              <span>{{props.row.projectCount}}</span>
            </template>
          </el-table-column>
          <el-table-column label="地区" width="130" align="center">
            <template slot-scope="props">
              <span>{{returnProjectCount(props.row.sysUserDivCount)}} </span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" align="center" width="300">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="handleEdit(scope.row, 'view')">查看详情</el-button>
              <span class="cutLine"></span>
              <el-button type="text" size="small" @click="handleEdit(scope.row, 'edit')" :disabled="auths.indexOf(2) == -1">编辑</el-button>
              <span class="cutLine"></span>
              <el-button type="text" size="small" @click="handleDelete(scope.$index, scope.row)" :disabled="auths.indexOf(2) == -1">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="pagination table-pagination" @size-change="handleSizeChange"
                       @current-change="handleCurrentChange" :current-page="pageNo" :page-sizes="[10, 20, 30, 40]"
                       :page-size="pageSize" layout="slot, total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </el-row>
    <!-- 创建用户弹窗 -->
    <el-dialog @close="createNewUserCancel" title="创建用户" :visible.sync="createNewUserModal" :center="true"
               :show-close="false"
               width="860px" class="dialog" top="24vh">
      <el-form :inline="true" size="mini" :model="tableForm" label-width="80px" :rules="rules" ref="newUserForm"
               class="formInline">
        <el-form-item label="人员编码" prop="empCode">
          <el-input v-model="tableForm.empCode" placeholder="请输入员工编码..."></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="nickName">
          <el-input v-model="tableForm.nickName" placeholder="请输入姓名..." :maxlength="60"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="tel">
          <el-input v-model.number="tableForm.tel" placeholder="请输入手机号码..." :maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="mail">
          <el-input v-model="tableForm.mail" placeholder="请输入邮箱..."></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="idCard">
          <el-input v-model="tableForm.idCard" placeholder="请输入身份证号..."></el-input>
        </el-form-item>
        <el-form-item label="用户名" prop="account">
          <el-input v-model="tableForm.account" placeholder="请输入用户名..." :minlength="6" :maxlength="16"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="loginPassword">
          <el-input v-model="tableForm.loginPassword" placeholder="请输入密码..." :minlength="6" :maxlength="16"></el-input>
        </el-form-item>
        <el-form-item label="角色" style="display:block;">
          <el-tag class="createEditTag" v-if="tableForm.roleName">
            {{tableForm.roleName}}
          </el-tag>
          <el-button round v-if="tableForm.roleName == ''" class="roleBtn" @click="openCreateNewRoleModal">
            <i class=" el-icon-plus"></i>
            增加
          </el-button>
          <el-button round v-else class="roleBtn" @click="openCreateNewRoleModal">修改</el-button>
        </el-form-item>
        <el-form-item label="地区" style="display:block;" class="wid90">
          <span v-for="(province, pIndex) in tableForm.regionLst" :key="pIndex">
            <el-tag class="createEditTag" v-for="(item,index) in province.cityLst" :key="index">
              {{item}}
            </el-tag>
          </span>
          <el-button round v-if="tableForm.regionLst.length === 0" class="roleBtn" @click="openCreateNewAreaModal">
            <i class=" el-icon-plus"></i>
            增加
          </el-button>
          <el-button round v-else class="roleBtn" @click="openCreateNewAreaModal">修改</el-button>
        </el-form-item>
        <el-form-item label="项目" style="display: block;" class="wid90">
          <el-tag class="createEditTag" v-for="(item,index) in tableForm.projectLst" :key="index">
            {{item.projectName}}
          </el-tag>
          <el-button round v-if="tableForm.projectLst.length === 0" class="roleBtn"
                     @click="openCreateNewProjectModal">
            <i class=" el-icon-plus"></i>
            增加
          </el-button>
          <el-button round v-else class="roleBtn" @click="openCreateNewProjectModal">修改</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button class="roleCancelBtn" @click="createNewUserCancel">取消</el-button>
        <el-button class="roleDefineBtn" @click="createNewUserSave" :loading='creatACKButtonLoading'>确定</el-button>
      </div>
    </el-dialog>
    <!-- 角色弹窗 -->
    <el-dialog title="角色" :visible.sync="createNewRoleModal" :center="true" :show-close="false" width="780px"
               class="dialog">
      <div class="common-search" style="margin-bottom:10px;">
        <el-form :inline="true" class="formInline" size="mini">
          <el-form-item label="角色名称">
            <el-input v-model="searchRole.sysRoleName" placeholder="请输入角色名称进行模糊搜索"
                      style="width:200px;margin-right:10px;"></el-input>
          </el-form-item>
          <el-form-item style="vertical-align: bottom;">
            <el-button class="search-btn" @click="handleSearchRole">筛选</el-button>
          </el-form-item>
          <el-form-item class="floatr" style="vertical-align: bottom;">
            <el-tag class="roleEditTag" v-show="checkedRoleId">
              {{checkedRoleName}}
              <i class="el-icon-circle-close-outline roleRightTag" @click="removeShowRoleTag"></i>
            </el-tag>
          </el-form-item>
        </el-form>
      </div>
      <div class="common-box-body" style="background-color:#f4f4f4;">
        <div style="padding: 15px 20px;max-height: 350px;overflow-y: auto">
          <el-button class="unCreateRoleTag" :class="{createRoleTag:item.id === checkedRoleId,marginL10:index == 0}"
                     v-for="(item,index) in roleData" :key="index" @click="addRoleTag(item)">
            {{item.roleName}}
          </el-button>
        </div>
      </div>
      <div slot="footer">
        <el-button class="roleCancelBtn" @click="createNewRoleModal = false">取消</el-button>
        <el-button class="roleDefineBtn" @click="createNewRoleSave">确定</el-button>
      </div>
    </el-dialog>
    <!-- 地区弹窗 -->
    <el-dialog title="地区" :visible.sync="createNewAreaModal" :center="true" :show-close="false" width="780px"
               class="dialog">
      <el-form :inline="true" size="mini">
        <el-form-item label="城市">
          <div style="width:670px;">
            <span v-for="(province, pIndex) in checkedRegionLst" :key="pIndex">
              <el-tag class="areaTag" v-for="(city, cIndex) in province.cityLst" :key="cIndex">
                {{city || '不限'}}
                <i class="el-icon-circle-close-outline areaIcon" @click="cancelCity(pIndex, cIndex)"></i>
              </el-tag>
            </span>
          </div>
        </el-form-item>
        <el-form-item label="省份">
          <div style="width:670px;">
            <el-tag class="areaTag" v-for="(province, pIndex) in checkedRegionLst" :key="pIndex"
                    v-if="province.cityLst.length != 0">
              {{province.province == 'countrywide' ? '不限':province.province}}
              <i class="el-icon-circle-close-outline areaIcon" @click="cancelProvince(pIndex)"></i>
            </el-tag>
          </div>
        </el-form-item>
        <div class="common-box-body" style="background-color:#f4f4f4;">
          <div style="margin:0 20px;padding: 15px 0;" class="userArea">
            <span style="margin-right:20px;">
              <img style="width:18px;height:18px;margin:-3px 7px 0 0" src="../../common/images/hot.png" alt="">热门城市</span>
            <el-button class="unPopularCityTag" v-for="(item,index) in popularCity" :key="index"
                       @click="areaSelectedSave(item.province, item.city)" :class="{popularCityTag:item.show}">
              {{item.city}}
            </el-button>
          </div>
        </div>
        <div class="common-box-body" style="background-color:#f4f4f4;">
          <div style="margin:0 20px;padding: 15px 0;" class="userAreaModal">
            <span style="margin-right:20px;">
              <i class="el-icon-location-outline" style="margin-right:10px;color:#f69c60;"></i>其他城市</span>
            <span style="margin-right:10px;">省</span>
            <el-select placeholder="请选择省份..." v-model="province" value-key="id" @change="getCities" filterable>
              <el-option v-for="(item,index) in provinceInfo" :key="index" :label="item.adName"
                         :value="item"></el-option>
            </el-select>
            <span style="margin-left:28px; margin-right:10px;">市</span>
            <el-select placeholder="请选择城市..." v-model="city" value-key="id" filterable>
              <el-option v-for="(item,index) in cityInfo" :key="index" :label="item.adName" :value="item"></el-option>
            </el-select>
            <el-button size="mini" class="areaModalSelectSave"
                       @click="areaSelectedSave(province ? province.adName : '', city ? city.adName: '')">确认选择
            </el-button>
          </div>
        </div>
      </el-form>
      <div slot="footer">
        <el-button class="roleCancelBtn" @click="createNewAreaModal = false;">取消</el-button>
        <el-button class="roleDefineBtn" @click="createNewAreaSave">确定</el-button>
      </div>
    </el-dialog>
    <!-- 项目弹窗 -->
    <el-dialog title="项目" :visible.sync="createNewProjectModal" :center="true" :show-close="false"
               width="1000px" class="dialog">
      <el-form :inline="true" size="mini">
        <el-tag class="projectTag" v-for="(item,index) in checkedPrjLst" :key="index">
          {{item.projectName}}
          <i class="el-icon-error areaIcon" @click="removeProject(item, index)"></i>
        </el-tag>
      </el-form>
      <div class="common-search" style="margin-bottom:10px;">
        <el-form :inline="true" class="formInline" size="mini">
          <el-form-item label="项目编号">
            <el-input v-model="projectInfo.projectCode" placeholder="请输入..."
                      style="width:180px;margin-right:10px;"></el-input>
          </el-form-item>
          <el-form-item label="项目名称">
            <el-input v-model="projectInfo.projectName" placeholder="请输入..."
                      style="width:180px;margin-right:10px;"></el-input>
          </el-form-item>
          <el-form-item label="客户名称">
            <el-input v-model="projectInfo.customer" placeholder="请输入..."
                      style="width:180px;margin-right:10px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="search-btn" @click="searchProject">筛选</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div style="background-color:#f4f4f4;padding:10px;">
        <el-checkbox class="usermangerCheck" v-model="checked" @change="selectAllProject">
          全选项目<span v-if="checked && projectRealTotal">：{{projectRealTotal}}条</span>
        </el-checkbox>
        <el-table v-if="!checked" @select="changeProject" @select-all="selectAllChange" class="userProjectTable"
                  style="width: 100%" :data="projectTableData" ref="projectTable" tooltip-effect="dark" size="small"
                  border header-row-class-name="table-header" v-loading="getProjectDataLoading">
          <el-table-column type="selection" width="50" align="center" label="全选"></el-table-column>
          <el-table-column prop="projectCode" label="项目编号" width="200" align="center"></el-table-column>
          <el-table-column prop="projectName" label="项目名称" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column prop="startTime" label="开始时间" width="120" align="center"></el-table-column>
          <el-table-column prop="endTime" label="结束时间" width="120" align="center"></el-table-column>
          <el-table-column prop="customer" label="客户名称" width="120" align="center"></el-table-column>
        </el-table>
        <el-pagination v-if="!checked" class="pagination" @current-change="projectHandleCurrentChange"
                       :current-page="projectInfo.pageNo" layout="slot, total, prev, pager, next, jumper"
                       :total="projectTotal">
        </el-pagination>

        <img style="display: block;margin: 0 auto;margin-top: 100px;margin-bottom: 100px;" v-if="checked"
             src="../../common/images/selectAllProjects.png" alt=""/>
      </div>
      <div slot="footer">
        <el-button class="roleCancelBtn" @click="createNewProjectModal = false">取消</el-button>
        <el-button class="roleDefineBtn" @click="createNewProjectSave">确定</el-button>
      </div>
    </el-dialog>
    <!-- 编辑与查看弹窗 -->
    <el-dialog class="dialog" :title="title" :visible.sync="editRowDialog" width="860px" :center="true"
               :show-close="false" @close="editUserCancel">
      <el-form :model="tableForm" :inline="true" size="mini" :rules="rules" ref="tableForm" label-width="80px"
               v-loading="dialogLoading" class="formInline">
        <el-form-item label="人员编码" prop="empCode">
          <el-input v-model="tableForm.empCode" placeholder="请输入员工编码..." :disabled="!isEdit" :maxlength="30"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="nickName">
          <el-input v-model="tableForm.nickName" placeholder="请输入角色名称..." :disabled="!isEdit"
                    :maxlength="60"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="tel">
          <el-input v-model="tableForm.tel" placeholder="请输入手机号码..." :disabled="!isEdit" :maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="mail">
          <el-input v-model="tableForm.mail" placeholder="请输入邮箱..." :disabled="!isEdit" :maxlength="30"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="idCard">
          <el-input v-model="tableForm.idCard" placeholder="请输入身份证号..." :disabled="!isEdit"
                    :maxlength="30"></el-input>
        </el-form-item>
        <el-form-item label="用户名" prop="account">
          <el-input v-model="tableForm.account" placeholder="请输入用户名..." :disabled="!isEdit" :minlength="6"
                    :maxlength="16"></el-input>
        </el-form-item>
        <el-form-item v-if="isAdmin" label="密码" prop="loginPassword">
          <el-input v-model="tableForm.loginPassword" placeholder="请输入密码..." :disabled="!isEdit" :minlength="6"
                    :maxlength="16"></el-input>
        </el-form-item>
        <el-form-item label="角色" style="display: block;">
          <el-tag v-if="tableForm.roleId" class="createEditTag">
            {{tableForm.roleName}}
          </el-tag>
          <!--<el-tag v-else class="createEditTag" v-for="(item,index) in showRoleTag" :key="index">-->
          <!--{{item.roleName}}-->
          <!--</el-tag>-->
          <el-button round class="roleBtn" @click="openCreateNewRoleModal" v-show="isEdit">修改</el-button>
        </el-form-item>
        <el-form-item label="地区" style="display: block;" class="wid90">
          <span v-for="(province, pIndex) in tableForm.regionLst" :key="pIndex">
            <el-tag class="createEditTag" v-for="(item,index) in province.cityLst" :key="index">
              {{returnCity(item,province)}}
            </el-tag>
          </span>
          <el-button round class="roleBtn" @click="openCreateNewAreaModal" v-show="isEdit">修改</el-button>
        </el-form-item>
        <el-form-item label="项目" size="mini" style="display:block" class="wid90">
          <div>
            <el-tag class="createEditTag" v-for="(item,index) in tableForm.projectLst" :key="index">
              {{item.projectName}}
            </el-tag>
            <el-button round class="roleBtn" @click="openCreateNewProjectModal" v-show="isEdit">修改</el-button>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button size="mini" class="rowCancel" @click="editUserCancel">取消</el-button>
        <el-button size="mini" class="rowSave" @click="rowHandleSave()" v-show="isEdit" :loading="editACKButtonLoading">
          确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import utils from '../../common/js/util.js'
  import globalRules from '../../common/js/formRules'

  export default {
    name: "userManager",
    data() {
      return {
        /*
        首页数据
        */
        auths: [],// 页面内权限，没用到。。
        //首页的筛选表单数据
        formData: {
          nickName: "",
          tel: "",
          empCode: "",
          roleId: "",
          pageNo: 1,
          pageSize: 10
        },
        isAdmin: false,//是否是admin1或者tinashi
        tableData: [],//筛选到的当页数据，table数据
        listLoading: true,//首页loading
        pageNo: 1,//默认显示第一页的数据
        pageSize: 10,//默认显示10条数据
        total: null,//总页数
        /*
        创建、编辑、查看弹框
        */
        createNewUserModal: false,//创建用户弹窗 显示还是隐藏
        editRowDialog: false,//编辑和查看用户弹窗 显示还是隐藏
        rules: {
          empCode: [
            {required: true, message: '请输入员工编码', trigger: 'blur'},
            {pattern: /^[^ ]+$/, message: '不能含有空格', trigger: 'blur'},
          ],
          nickName: [
            {required: true, message: '请输入姓名', trigger: 'blur'},
            {pattern: /^[^ ]+$/, message: '不能含有空格', trigger: 'blur'},
            {max: 60, message: '最长为 60 个中文字符', trigger: 'blur'}
          ],
          account: [
            {required: true, message: '请输入用户名', trigger: 'blur'},
            {pattern: /^[^ ]+$/, message: '不能含有空格', trigger: 'blur'},
          ],
          loginPassword: [
            {required: true, message: '请输入密码', trigger: 'blur'},
            {pattern: /^[^ ]+$/, message: '不能含有空格', trigger: 'blur'},
          ],
          idCard: [globalRules.idcard],
          mail: [{pattern: /^(\w)+(\.\w+)*@(\w)+((\.\w{2,3}){1,3})$/, message: '请输入正确邮箱', trigger: 'blur'}],
          tel: [{pattern: /^1[3456789]\d{9}$/, message: '请输入正确手机号', trigger: 'blur'}]
        },//创建或编辑的表单校验规则
        title: "",//编辑查看弹框-标题-编辑还是查看
        // 创建或编辑或查看中的表单及详情内容
        tableForm: {
          empCode: '',//后面用户要求加入人员编码作为必填项
          id: null,
          account: '',
          loginPassword: '',
          nickName: '',
          tel: '',
          mail: '',
          idCard: '',
          roleId: null,
          roleName: '',
          regionLst: [],
          projectIdLst: [],
          projectLst: []//选择项目弹框，一级已选项目数据（全部信息）
        },
        dialogLoading: false,//编辑查看弹框的loading
        creatACKButtonLoading: false,//创建用户确认按钮，是否loading
        editACKButtonLoading: false,//编辑用户确认按钮，是否loading
        showRoleTag: [],//在创建弹窗显示角色?????
        /*
        选择角色弹框
        */
        createNewRoleModal: false,//角色弹窗 显示还是隐藏
        roleData: [],  //角色弹框-供选择的角色列表
        roleList: [],
        checkedRoleId: null,//选择角色弹框
        checkedRoleName: '',//选择角色弹框
        //选择角色弹框-模糊搜索角色，因为只有一页，所以pageSize设置极大
        searchRole: {
          sysRoleName: "",
          pageNo: 1,
          pageSize: 1000
        },
        /*
        选择地区弹框
        */
        createNewAreaModal: false,//地区弹窗 显示还是隐藏
        checkedRegionLst: [],//选择地区弹框
        provinceInfo: [],//选择地区弹框-省的下拉列表信息
        province: null,//v-model绑定的省下拉框中的信息
        cityInfo: [],//选择地区弹框-市的信息
        city: null,//v-model绑定的市下拉框中的信息
        //热门城市
        popularCity: [
          {province: "不限", city: "不限"},
          {province: "北京市", city: "北京市"},
          {province: "天津市", city: "天津市"},
          {province: "广东省", city: "广州市"},
          {province: "广东省", city: "深圳市",},
          {province: "上海市", city: "上海市"},
          {province: "四川省", city: "成都市"},
          {province: "重庆市", city: "重庆市"},
          {province: "黑龙江省", city: "哈尔滨市"},
          {province: "陕西省", city: "西安市"},
          {province: "浙江省", city: "杭州市"},
          {province: "江苏省", city: "南京市"},
          {province: "湖南省", city: "长沙市"},
          {province: "河南省", city: "郑州市"},
          {province: "福建省", city: "厦门市"},
          {province: "福建省", city: "福州市"},
          {province: "广西壮族自治区", city: "南宁市"},
          {province: "山东省", city: "青岛市"},
          {province: "新疆维吾尔自治区", city: "乌鲁木齐市"},
          {province: "辽宁省", city: "大连市"},
          {province: "山西省", city: "太原市"},
          {province: "辽宁省", city: "沈阳市"},
          {province: "吉林省", city: "长春市"},
          {province: "甘肃省", city: "兰州市"}
        ],
        /*
        选择项目弹框
        */
        createNewProjectModal: false,//项目弹窗 显示还是隐藏
        checked: false,//选择项目弹框-是否全选
        //选择项目弹窗--筛选项目的表单信息
        projectInfo: {
          projectCode: "",
          projectName: "",
          customer: "",
          pageNo: 1,
          pageSize: 10
        },
        projectTotal: null,//项目弹窗-筛选到的项目总数
        projectRealTotal: null,//项目弹窗-全部项目数，而非检索到的总项目数
        projectTableData: [],//项目弹窗-筛选到的当页数据，table数据
        checkedPrjLst: [],//选择项目弹框，二级已选项目数据（全部信息）
        getProjectDataLoading: false,//getProjectData时候的table loading
      };
    },
    computed: {
      // 是否是编辑状态
      isEdit() {
        if (this.title == "查看详情") {
          return false
        } else {//用户编辑
          return true
        }
      }
    },
    mounted() {
      // 180627韩金辰优化重写，变动较大(变动前此文件svn版本：2942)
      this.getData(true);
      let user = sessionStorage.getItem('user')
      if (user == 'admin1' || user == 'tinashi') {
        this.isAdmin = true
      }
      this.getAuth();
      this.getCities();
      this.getRoleList();
    },
    methods: {
      /*
      首页方法
      */
      //工具类-弹窗简写
      myNotify(_this, type, normal, or) {
        utils.myNotify(_this, type, normal, or)
      },
      //首页-table行-点击表格中编辑和查看详情按钮
      handleEdit(row, handle) {
        if (handle == "view") {
          this.title = "查看详情"
        } else {
          this.title = "用户编辑"
        }
        this.editRowDialog = true
        this.dialogLoading = true
        this.$http({
          method: "GET",
          url: '/rest/sysUser/getSysUserDetail',
          params: {
            sysUserId: row.sysUser.id,
          }
        }).then(res => {
          let role = res.data.sysRole
          let sysUser = res.data.sysUser
          this.tableForm = {
            empCode: sysUser.empCode,
            id: sysUser.id,
            account: sysUser.account,
            loginPassword: sysUser.loginPassword,
            nickName: sysUser.nickName,
            tel: sysUser.tel,
            mail: sysUser.mail,
            idCard: sysUser.idCard,
            roleId: role ? role.id : null,
            roleName: role ? role.roleName : null,
            regionLst: [],
            projectIdLst: [],
            projectLst: []
          }

          let sysUserDivLst = res.data.sysUserDivLst
          if (sysUserDivLst) {
            sysUserDivLst.map(item => {
              if (this.isProvinceInArray(this.tableForm.regionLst, item.province)) {
                this.tableForm.regionLst.map(province => {
                  if (province.province === item.province) {
                    province.cityLst.push(item.city)
                  }
                })
              } else {
                this.tableForm.regionLst.push({
                  province: item.province,
                  // cityLength: this.city.length,
                  cityLst: [item.city]
                })
              }
            })
          }

          let projectLst = res.data.projectLst
          if (projectLst) {
            projectLst.map(item => {
              this.tableForm.projectLst.push({
                id: item.id,
                projectName: item.id == -1 ? '不限' : item.projectName
              })
            })
          }

          this.dialogLoading = false
        }).catch(err => {
          this.dialogLoading = false
          this.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
      },
      //首页-table行-删除用户
      handleDelete(index, row) {
        this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http({
            method: "POST",
            url: "/rest/sysUser/deleteUser",
            data: {
              id: row.sysUser.id
            }
          }).then(res => {
            this.myNotify(this, 'success', res, '删除成功')
            this.getData(true)
          }).catch(err => {
            this.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
          });
        }).catch(() => {
        })
      },
      //主页table中用的项目数量的转换
      returnProjectCount(count) {
        if (count == -1) {
          return '不限'
        } else {
          return count
        }
      },
      //主页-获取数据
      getData(reset) {
        this.listLoading = true;
        let params = this.formData
        if (reset) {
          params.pageNo = 1;
          params.pageSize = 10
        }
        this.$http({
          // method: "GET",
          url: "/rest/sysUser/searchSysUser",
          params: params
        }).then(res => {
          //搜索时没有权限，进行提示
          if (res.data.status == 460) {
            this.myNotify(this, 'error', res, '查询失败，请稍后重试')
            return false
          }
          this.listLoading = false;
          this.tableData = res.data;
        }).catch(err => {
          if (err.response) {
            this.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
          }
          this.listLoading = false;
        })

        this.$http({
          method: "GET",
          url: "/rest/sysUser/countSysUser",
          params: this.formData
        }).then(res => {
          this.total = res.data
        }).catch(err => {
          this.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
      },
      //主页-获取权限，没用到，留着吧先
      getAuth() {
        this.$http({
          method: "GET",
          url: "/rest/sysUser/getSysUserWebAuth",
          params: {
            webId: 14,
            sysUserId: sessionStorage.getItem("sysUserId")
          }
        }).then(res => {
          res.data.map(item => {
            this.auths.push(item.auth)
          })
        }).catch(err => {
          this.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
      },
      //主页-切换table，Size
      handleSizeChange(val) {
        //更改页面数据条数
        this.formData.pageSize = val;
        //更改新的页面数据条数后，重新请求数据
        this.getData(false);
      },
      //主页-切换table，pageNo
      handleCurrentChange(val) {
        //更改页数
        this.formData.pageNo = val;
        //更改新的页数后，重新请求数据
        this.getData(false);
      },
      /*
      创建、编辑、查看弹框-方法
      */
      // 打开创建用户对话框
      showNewUserDialog() {
        this.createNewUserModal = true
        this.tableForm = {
          id: null,
          account: '',
          loginPassword: '',
          nickName: '',
          tel: '',
          mail: '',
          idCard: '',
          roleId: null,
          roleName: '',
          regionLst: [],
          projectIdLst: [],
          projectLst: []
        }
      },
      //查看和编辑弹窗-将选择的地区转换为城市
      //创建时候都没用这个，直接用的循环中的item，不知道这个方法有啥用，先留着吧
      returnCity(i, obj) {
        // console.log(i,obj)
        if (i == 'allcity') {
          return obj.province
        } else if (i == null) {
          return '不限'
        } else {
          return i
        }
      },
      //创建用户弹框-关闭弹框
      createNewUserCancel() {
        this.createNewUserModal = false;
        this.$refs['newUserForm'].resetFields();
      },
      //创建用户弹框-点击确定
      createNewUserSave() {
        this.$refs['newUserForm'].validate((valid) => {
          if (valid) {
            this.creatACKButtonLoading = true;
            let data = this.tableForm
            data.projectIdLst = []
            data.projectLst.map(item => {
              data.projectIdLst.push(item.id)
            })

            data.regionLst.map(item => {
              if (item.province == '不限' && item.cityLst[0] == '不限') {
                data.regionLst = []
                data.regionLst.push({
                  province: 'countrywide',
                  cityLst: []
                })
              }
            })

            data.regionLst.map((item, index) => {
              if (item.cityLst.length == 0 && item.province !== "countrywide") {
                data.regionLst.splice(index, 1)
              }
            })

            data.regionLst.map(item => {
              if (item.province == '北京市' || item.province == '天津市' || item.province == '上海市' || item.province == '重庆市') {
                item.cityLst = ['allcity']
              }
            })

            this.$http({
              method: "POST",
              url: "/rest/sysUser/saveUpdateUser",
              data: {
                empCode: data.empCode,
                id: data.id,
                account: data.account,
                loginPassword: data.loginPassword,
                nickName: data.nickName,
                tel: data.tel,
                mail: data.mail,
                idCard: data.idCard,
                roleId: data.roleId,
                regionLst: data.regionLst,
                projectIdLst: data.projectIdLst,
              }
            }).then(res => {
              this.myNotify(this, 'success', res, '保存成功')

              this.createNewUserModal = false;
              this.creatACKButtonLoading = false;
              this.$refs['newUserForm'].resetFields();
              this.getData(true)
            }).catch(err => {
              this.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
              this.creatACKButtonLoading = false
            });
          } else {
            return false;
          }
        });
      },
      //编辑或查看弹窗-关闭弹框
      editUserCancel() {
        //先将展开一行的方法，设置为false
        if (this.title == "用户编辑") {
          this.$refs['tableForm'].resetFields();
        }
        this.editRowDialog = false
      },
      //编辑或查看弹窗-点击确定
      rowHandleSave() {
        this.$refs['tableForm'].validate((valid) => {
          if (valid) {
            this.editACKButtonLoading = true
            let data = this.tableForm
            data.projectLst.map(item => {
              data.projectIdLst.push(item.id)
            })
            data.projectIdLst.map((item, index) => {
              if (item == undefined || item == null) {
                data.projectIdLst.splice(index, 1)
              }
            })

            data.regionLst.map(item => {
              if (item.province == '不限' && item.cityLst[0] == '不限') {
                data.regionLst = []
                data.regionLst.push({
                  province: 'countrywide',
                  cityLst: []
                })
              }
            })

            data.regionLst.map((item, index) => {
              if (item.cityLst.length == 0 && item.province !== "countrywide") {
                data.regionLst.splice(index, 1)
              }
            })

            // data.regionLst.map(item => {
            //   if(item.province == '北京市' || item.province == '天津市' || item.province == '上海市' || item.province == '重庆市' ){
            //     // item.cityLst = ['allcity']
            //   }
            // })
            // console.log(data.regionLst)

            var cccc = [].concat(data.regionLst);
            cccc.map(item => {
              if (item.province == '北京市' || item.province == '天津市' || item.province == '上海市' || item.province == '重庆市') {
                item.cityLst = ['allcity']
              }
            })

            this.$http({
              method: "POST",
              url: "/rest/sysUser/saveUpdateUser",
              data: {
                empCode: data.empCode,
                id: data.id,
                account: data.account,
                loginPassword: data.loginPassword,
                nickName: data.nickName,
                tel: data.tel,
                mail: data.mail,
                idCard: data.idCard,
                roleId: data.roleId,
                regionLst: cccc,
                projectIdLst: data.projectIdLst,
              }
            }).then(res => {
              this.editACKButtonLoading = false
              this.myNotify(this, 'success', res, '保存成功')
              this.createNewUserModal = false;
              this.editRowDialog = false
              this.getData(true)
            }).catch(err => {
              this.editACKButtonLoading = false
              this.myNotify(this, 'error', err.response, '操作失败，请稍后重试')
            });
          } else {
            return false;
          }
        });
      },
      /*
      选择角色弹框-方法
      */
      // 打开角色弹窗
      openCreateNewRoleModal() {
        this.checkedRoleId = this.tableForm.roleId
        this.checkedRoleName = this.tableForm.roleName
        this.createNewRoleModal = true;
        this.handleSearchRole()
      },
      // 搜索角色
      handleSearchRole() {
        this.$http({
          method: "GET",
          url: "/rest/sysUser/searchRole",
          params: this.searchRole
        }).then(res => {
          this.roleData = res.data
        }).catch(err => {
          this.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
      },
      // 搜索角色
      getRoleList() {
        this.$http({
          method: "GET",
          url: "/rest/sysUser/searchRole",
          params: {
            pageNo: 1,
            pageSize: 1000
          }
        }).then(res => {
          this.roleList= res.data
        }).catch(err => {
          this.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
      },
      //选择角色
      addRoleTag(item) {
        this.checkedRoleId = item.id
        this.checkedRoleName = item.roleName
      },
      //删除已选择的角色
      removeShowRoleTag() {
        this.checkedRoleId = null
        this.checkedRoleName = ''
      },
      //选择角色弹窗-点击确定
      createNewRoleSave() {
        this.createNewRoleModal = false;
        this.tableForm.roleId = this.checkedRoleId
        this.tableForm.roleName = this.checkedRoleName
      },
      /*
      选择地区弹框
      */
      //打开地区弹窗
      openCreateNewAreaModal() {
        this.city = null
        this.province = null
        this.checkedRegionLst = this.tableForm.regionLst.slice(0)
        this.createNewAreaModal = true;
        this.$http({
          method: "POST",
          url: "/rest/salesman/getRegion",
          params: {
            deep: 1,
            regionId: null
          }
        }).then(res => {
          this.provinceInfo = res.data;
        }).catch(err => {
          this.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
        //默认不选择省就不出城市
      },
      //选择地区弹窗-省的下拉框值变化时，自动获取市的列表，并且转码
      getCities(province) {
        this.city = ''
        if (
          // province && province.id != null
          true
        ) {
          this.$http({
            method: "POST",
            url: "/rest/salesman/getRegion",
            params: {
              deep: 2,
              // regionId: province.id
            }
          }).then(res => {
            //在map过程中多次splice极有可能出现index错乱，只能用笨点的办法
            let delArr = []
            res.data.map((item, index) => {
              switch (item.id) {
                case 15:
                case 37:
                case 873:
                case 2458:
                  delArr.unshift(index)
                  break;//有时city的名字是‘县’，需要去掉
                case 2:
                case 23:
                case 873:
                case 2458:
                  item.adName = item.adName.replace('市辖区', "")
                  break;//把上海市市辖区这种，换成上海市
              }
            })
            delArr.map(item => {
              res.data.splice(item, 1)
            })
            setTimeout(() => {
              this.cityInfo = res.data;
            }, 30)
          })
        }
      },
      //选择地区弹框-点击每个热门城市按钮
      areaSelectedSave(province, city) {
        if (province) {
          if (this.isProvinceInArray(this.checkedRegionLst, province)) {
            this.checkedRegionLst.map(item => {
              if (item.province === province && item.cityLst.indexOf(city) < 0) {
                item.cityLst.push(city)
              }
            })
          } else {
            if (city) {
              this.checkedRegionLst.push({
                province: province,
                // cityLength: this.city.length,
                cityLst: [city]
              })
            } else {
              let cityArr = []
              this.cityInfo.map(city => {
                cityArr.push(city.adName)
              })
              this.checkedRegionLst.push({
                province: province,
                // cityLength: this.city.length,
                cityLst: cityArr
              })
            }
          }
        }
        if (province == '不限') {
          this.checkedRegionLst = []
          this.checkedRegionLst.push({
            province: '不限',
            cityLst: ['不限']
          })
        } else if (province != '不限') {
          this.checkedRegionLst.map((item, index) => {
            if (item.province == '不限' || item.province == 'countrywide') {
              this.checkedRegionLst.splice(index, 1)
            }
          })
        }
        // if(province)
      },
      //选择地区弹框-删除已选中的城市
      cancelCity(pIndex, cIndex) {
        this.checkedRegionLst[pIndex].cityLst.splice(cIndex, 1);
        this.tableForm.regionLst.map((item, index) => {
          if (item.province == 'countrywide') {
            this.cancelProvince()
          }
        })
      },
      //选择地区弹框-删除已选中的省
      cancelProvince(index) {
        this.checkedRegionLst.splice(index, 1);
        this.tableForm.regionLst.map((item, index) => {
          if (item.province == 'countrywide') {
            this.tableForm.regionLst.splice(index, 1)
          }
        })
      },
      //选择地区弹框-确定
      createNewAreaSave() {
        this.createNewAreaModal = false;
        this.tableForm.regionLst = this.checkedRegionLst.slice(0)
      },
      //查看添加的省是否在已选的列表中
      isProvinceInArray(arr, val) {
        for (var i = 0; i < arr.length; i++) {
          if (val == arr[i].province) {
            return true
          }
        }
        return false
      },
      /*
      选择项目弹框-方法
      */
      //打开项目弹窗
      openCreateNewProjectModal() {
        //数组的深拷贝可以用.slice(0)，之前用的map+push有点笨
        this.checkedPrjLst = this.tableForm.projectLst.slice(0)
        if (this.checkedPrjLst[0] && this.checkedPrjLst[0].projectName == '不限') {
          this.checked = true
        } else {
          this.checked = false
        }
        this.createNewProjectModal = true;
        this.projectInfo = {
          projectCode: "",
          projectName: "",
          customer: "",
          pageNo: 1,
          pageSize: 10
        }
        this.getProjectData();
      },
      //项目弹框-选择全部项目@change
      selectAllProject() {
        this.checkedPrjLst = []
        if (this.checked) {
          this.checkedPrjLst.push({
            projectName: '不限',
            id: -1
          })
        } else {
          this.getProjectData()
        }
      },
      //选择项目弹框，点击筛选
      searchProject() {
        this.projectInfo.pageNo = 1
        this.getProjectData();
      },
      //传参this.projectInfo，获取及筛选项目信息
      getProjectData() {
        this.getProjectDataLoading = true
        this.$http({
          method: "GET",
          url: "/rest/sysUser/searchProject",
          params: this.projectInfo
        }).then(res => {
          this.getProjectDataLoading = false
          this.projectTableData = res.data;
          setTimeout(() => {
            this.refreshProTableChecked()
          }, 20)
        }).catch(err => {
          this.getProjectDataLoading = false
          this.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })

        this.$http({
          method: "GET",
          url: "/rest/sysUser/countProject",
          params: this.projectInfo
        }).then(res => {
          //仅在第一次进入的时候获取总的项目条数（此时没有填写筛选项，所以是真的总项目数）
          if (!this.projectRealTotal) {
            this.projectRealTotal = res.data
          }
          this.projectTotal = res.data
        }).catch(err => {
          this.myNotify(this, 'error', err.response, '查询失败，请稍后重试')
        })
      },
      //根据this.projectInfo更新table的选中状态
      refreshProTableChecked() {
        let ids = []
        this.checkedPrjLst.map(item => {
          ids.push(item.id)
        })
        this.projectTableData.map(item => {
          if (ids.indexOf(item.id) > -1) {
            this.$refs["projectTable"].toggleRowSelection(item, true);
          }
        })
      },
      //删除项目
      removeProject(item, index) {
        if (item.projectName == '不限') {
          this.checked = false
          this.getProjectData()
        } else {
          this.projectTableData.map(i => {
            if (item.id === i.id) {
              this.$refs["projectTable"].toggleRowSelection(i, false);
            }
          })
        }
        this.checkedPrjLst.splice(index, 1)
      },
      //选择项目弹框-全选或取消全选选择项目
      selectAllChange(selection) {
        //全选
        if (selection.length == this.projectTableData.length) {
          let ids = []
          this.checkedPrjLst.map(item => {
            ids.push(item.id)
          })
          selection.map(item => {
            if (ids.indexOf(item.id) < 0) {
              this.checkedPrjLst.push(item)
            }
          })
        } else {
          //取消全选
          let delArr = [];
          this.projectTableData.map(item => {
            this.checkedPrjLst.map((item2, index) => {
              if (item.id == item2.id) {
                delArr.unshift(index)
              }
            })
          })
          delArr.map(item => {
            this.checkedPrjLst.splice(item, 1)
          })
        }
      },
      //选择项目弹框-单独选择或取消选择项目
      changeProject(selection, row) {
        let ids = []
        this.checkedPrjLst.map((item, index, arr) => {
          ids.push(item.id)
          if (item.id == row.id) {
            arr.splice(index, 1)
          }
        })
        if (ids.indexOf(row.id) < 0) {
          this.checkedPrjLst.push(row)
        }
      },
      //选择项目弹框-点击确定
      createNewProjectSave() {
        this.createNewProjectModal = false; //关闭项目弹窗
        this.tableForm.projectLst = this.checkedPrjLst.slice(0)
      },
      //选择项目弹框-切换页码
      projectHandleCurrentChange(val) {
        this.projectInfo.pageNo = val;//更改页数
        this.getProjectData();//更改新的页数后，重新请求数据
      },
    }
  };
</script>
<style scoped>
  /* 操作里的分割线 */
  .cutLine {
    border-right: 1px solid #82bc82;
    margin: 0 10px;
    position: relative;
    right: 1px;
  }

  /* 每一行展开后取消按钮样式 */
  .rowCancel {
    background-color: #dedede;
    color: #666666;
    border: none;
  }

  /* 每一行展开后保存按钮样式 */
  .rowSave {
    background-color: #8299dc;
    color: #ffffff;
    border: none;
  }

  /* table点击编辑后显示的取消、确定按钮的位置 */
  .tableBottomBtn {
    margin: 0 20px;
    padding-bottom: 20px;
  }

  /* 每一行展开后修改按钮的样式 */
  .roleBtn,
  .roleBtn:active {
    color: #8198db;
    border-color: #8198db;
    background-color: #ffffff;
    height: 30px;
  }

  /* table中点击编辑之后和创建角色 展示的可查看页面的标签样式 */
  .createEditTag {
    margin-right: 10px;
    margin-bottom: 10px;
    padding: 0 20px;
    border-radius: 20px;
    background-color: #f4f4f4;
    border: none;
  }

  /* 角色管理弹窗 tag样式 */
  .unCreateRoleTag {
    background-color: #ffffff;
    color: #8198db;
    padding: 0 20px;
    border: none;
    cursor: pointer;
    border-radius: 20px;
    height: 30px;
    line-height: 30px;
    margin-right: 8px;
    margin-bottom: 10px;
  }

  .createRoleTag {
    background-color: #8198db !important;
    color: #ffffff !important;
    padding: 0 20px;
    border: none;
    cursor: pointer;
    border-radius: 20px;
    height: 30px;
    line-height: 30px;
    margin-right: 8px;
    margin-bottom: 10px;
  }

  .marginL10 {
    margin-left: 10px
  }

  /* 角色弹窗顶部右侧标签 */
  .roleEditTag {
    background-color: #8198db;
    color: #ffffff;
    margin: 5px;
    padding: 0 5px 0 20px;
    border: none;
    cursor: pointer;
    border-radius: 20px;
    height: 30px;
    line-height: 30px;
  }

  /* 创建新用户按钮样式 */
  .newUser {
    background-color: #8198db;
    border-radius: 20px;
  }

  /* 创建角色中的取消按钮样式 */
  .roleCancelBtn,
  .roleCancelBtn:hover {
    height: 30px;
    color: #666666;
    border: none;
    font-size: 12px;
    padding: 7px 18px;
    background-color: #ffffff;
  }

  /* 创建角色中的确定按钮样式 */
  .roleDefineBtn {
    background: #2d2c7a;
    height: 30px;
    color: #ffffff;
    border: none;
    font-size: 12px;
    padding: 7px 18px;
  }

  /* 角色头部右侧tag 样式 */
  .roleRightTag {
    margin-left: 13px;
    font-size: 20px;
    position: relative;
    top: 4px;
  }

  /* 地区tag样式 */
  .areaTag {
    background-color: #8198db;
    color: #ffffff;
    padding: 0 5px 0 20px;
    border: none;
    cursor: pointer;
    border-radius: 20px;
    height: 30px;
    line-height: 30px;
    margin-right: 8px;
    margin-bottom: 10px;
  }

  /* 热门城市样式 */
  .unPopularCityTag {
    background-color: #ffffff;
    color: #8198db;
    padding: 0 20px;
    border: none;
    cursor: pointer;
    border-radius: 20px;
    height: 30px;
    line-height: 30px;
    margin-right: 8px;
    margin-bottom: 10px;
  }

  .popularCityTag {
    background-color: #8198db;
    color: #ffffff;
    padding: 0 20px;
    border: none;
    cursor: pointer;
    border-radius: 20px;
    height: 30px;
    line-height: 30px;
    margin-right: 8px;
    margin-bottom: 10px;
  }

  /* 地区icon样式 */
  .areaIcon {
    margin-left: 10px;
    font-size: 20px;
    position: relative;
    top: 4px;
  }

  /* 地区弹窗底部右侧确认按钮 */
  .areaModalSelectSave {
    margin-left: 38px;
    background-color: #8299dc;
    color: #ffffff;
    border: none;
  }

  /* 项目tag样式 */
  .projectTag {
    background-color: #8198db;
    color: #ffffff;
    padding: 0 5px 0 20px;
    border: none;
    cursor: pointer;
    border-radius: 20px;
    height: 30px;
    line-height: 30px;
    margin-right: 8px;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/limit/userManager.vue